"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortedData = void 0;
const react_1 = require("react");
const getValueByPath = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
};
const sortData = (data, sortMethod, sortDirection) => {
    const sortable = [...data];
    sortable.sort((a, b) => {
        const aVal = getValueByPath(a, sortMethod);
        const bVal = getValueByPath(b, sortMethod);
        if (aVal < bVal)
            return -1 * sortDirection;
        if (aVal > bVal)
            return 1 * sortDirection;
        if (a.id < b.id)
            return -1 * sortDirection;
        if (a.id > b.id)
            return 1 * sortDirection;
        return 0;
    });
    return sortable;
};
const useSortedData = (data, sort, sortDirection) => {
    const [sortedData, setSortedData] = (0, react_1.useState)(data);
    const [sortMethod, setSortMethod] = (0, react_1.useState)(sort);
    const [sortDir, setSortDirection] = (0, react_1.useState)(sortDirection);
    (0, react_1.useEffect)(() => {
        if (sortMethod && sortDir) {
            setSortedData(sortData(data, sortMethod, sortDir));
        }
        else {
            // When no sort is selected yet, just reflect the incoming data
            setSortedData(data);
        }
    }, [data, sortMethod, sortDir]);
    const setSort = (method, direction) => {
        setSortMethod(method);
        setSortDirection(direction);
    };
    return {
        sortedData,
        sortMethod,
        sortDirection: sortDir,
        setSort,
    };
};
exports.useSortedData = useSortedData;
